import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import { useCart } from '@/providers/CartProvider'

export function CartBadge() {
  const { count } = useCart()

  return (
    <Link to="/cart" className="text-slate-600 hover:text-navy transition-colors flex items-center relative">
      <Icon icon="solar:cart-large-minimalistic-linear" className="text-xl" />
      {count > 0 && (
        <span className="absolute -top-2 -right-2 w-5 h-5 bg-rust text-white text-[10px] font-medium rounded-full flex items-center justify-center">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  )
}
